<template>
  <section class="main">
    <ul class="main__banner">
      <li class="main__item">
        <div class="banner">
          <div
            class="banner__top"
            aria-hidden="true"
          >
            <p class="banner__img">
              <template
                v-for="(item, index) in hero"
              >
                <transition
                  :key="`hero_transion_${index}`"
                  name="bounce"
                >
                  <img
                    :key="`hero_image_${index}`"
                    :class="current === index ? 'on':''"
                    :src="`/content/images/${item.image}`"
                    :alt="`${item.name}`"
                  >
                </transition>
              </template>
            </p>
          </div>
          <div class="banner__center">
            <template
              v-for="(item, index) in hero"
            >
              <transition
                :key="`hero_transion_${index}`"
                name="slide-fade"
              >
                <h1
                  v-show="current === index"
                  :key="`hero_title_${index}`"
                  class="title title--main"
                >
                  {{ item.title }}
                </h1>
              </transition>
            </template>
            <h4 class="description description--main">
              UI Lab이 함께 만들어 갑니다
            </h4>
          </div>
          <div class="banner__bottom">
            <ul class="banner__buttons">
              <li class="banner__buttonitem">
                <button
                  type="button"
                  class="button button--primary button--large"
                  @click="openModal('request')"
                >
                  프로젝트 의뢰하기
                </button>
              </li>
              <li class="banner__buttonitem">
                <button
                  type="button"
                  class="button button--large"
                  @click="openModal('inquiry')"
                >
                  문의하기
                </button>
              </li>
            </ul> 
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Hero',
  components:{
  },
	data() {
    return {
			hero: [],
			current: 0,
			heroLen: 0,
      timer: null,
		} 
  },
  computed: {
	},
  watch: {},
  created() {
		this.getData()
	},
  mounted() {
	},
  methods: {
		getData() {
			axios.get(`${process.env.BASE_URL}data/hero.json`)
				.then(response => {
					this.hero = response.data
					this.heroLen = this.hero.length
					setTimeout(() => {
						this.startMotions()
					}, 1)
				})
				.catch(error => {
					this.$eventHub.$emit('showError', error)
				})
				.then(() => {
				})
		},
		openModal(target) {
      if (target === 'request') {
        this.$gtag.query('event', 'Request', {
          app_name: 'UILab Homepage',
          screen_name: 'Request Popup',
        })
      }
      this.$store.commit('modalOpen', target)
		},
		startMotions() {
			this.repeatMotion()
		},
		endMotions() {
			if (this.timer != null) {
				clearTimeout(this.timer)
			}
		},
		repeatMotion() {
			this.timer = setTimeout(() => {
				if (this.current < (this.heroLen - 1)) {
					this.current++
				} else {
					this.current = 0
				}
				this.repeatMotion()
			}, 5000)
		}
	}
}
</script>

<style lang="scss" scoped>
.main{
  $self:&;
  width:100%;
  height:620px;
  overflow: hidden;
  &__banner{
    width:100%;
    height:auto;
  }
  &__item{
    width:1000px;
    height:620px;
    padding:120px 0 110px 0;
    margin:0 auto;
  }
}
.banner{
  text-align:center;
  width:100%;
  height:100%;
  &__img {
    height:200px;
    position:relative;
    text-align: center;
    img {
      position:absolute;
      top:50px;
      left:0;
      transform:
        perspective(1500px)
        rotateX(80deg);
      opacity: 0;
      transition:0.5s ease all;
      &.on {
        transform:
          rotate(0deg)
          translateY(-50px);
        opacity: 1;
      }
    }
  }
  &__center {
    height:99px;
    position:relative;
    padding-top:56px;
    h1 {
      position: absolute;
      top:0;
      width:100%;
      text-align: center;
    }
  }
  &__top{
    margin:0 auto;
    width:260px;
    height:200px;
  }
  &__bottom{
    padding-top:30px;
    width:370px;
    height:auto;
    margin:0 auto;
  }
  &__buttonitem{
    width:180px;
    height:55px;
    float:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter{
  transform: translateX(50px);
  opacity: 0;
}
.slide-fade-leave-to{
  transform: translateX(-50px);
  opacity: 0;
}
</style>